import { render, staticRenderFns } from "./ModalAvisoValidacaoRenspaAR.vue?vue&type=template&id=ec0c6e96&lang=pug"
import script from "./ModalAvisoValidacaoRenspaAR.vue?vue&type=script&lang=js"
export * from "./ModalAvisoValidacaoRenspaAR.vue?vue&type=script&lang=js"
import style0 from "./ModalAvisoValidacaoRenspaAR.vue?vue&type=style&index=0&id=ec0c6e96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports